<template>
    <div>
        <v-col cols="12" v-if="saveError">
            <v-alert text type="error">{{ loadError }}</v-alert>
        </v-col>
        <v-badge
            bordered
            color="green"
            overlap
            v-if="auth.hasPermissions([permissions.ACCESS_LEVELS.VET_MED_TEAM], true)"
            :content="followupsNumber"
        >
            <v-btn
                fab
                small
                color="red"
                @click="followupDialog=true"
            >
                <v-icon color="white" large>
                    info
                </v-icon>
            </v-btn>
        </v-badge>       
        <FollowupList
            v-if="followupDialog"
            :dialog="followupDialog" 
            @cancel="hideFollowupList"
        >
        </FollowupList>
    </div>
</template>

<script>

import * as auth from '../../services/auth';
import { mapGetters } from 'vuex';
import permissions from 'comunet-btg-utah-repository-shared/permissions';
import FollowupList from "./FollowupList.vue";
export default {
    components: {
        FollowupList,
    },
    props: {
        specimenID: {
            type: String,
            default: ""
        },
        medicalRecordID: {
            type: String,
            default: ""
        }   
    } ,
    data() {
        return {
            followupDialog: false,
            auth: auth,
            permissions: permissions,
            params:{
                allFollowupsOfCurrentUser: true,
                allVetFollowups: false
            },
            loadError: '',
        };
    },
    computed: {
        ...mapGetters({
            followups: "medicalRecordStore/getFollowupsOfCurrentUser",
            followupsNumber: "medicalRecordStore/getNumberOfFollowups",
        }),
    },
    methods: {
        hideFollowupList() {
            this.followupDialog = false;
        },
        async loadFollowupsOfCurrentUser() {
            try {
                await this.$store.dispatch("medicalRecordStore/loadFollowupsOfCurrentUser",this.params);
            } catch (e) {
                this.loadError = e.message
            }
        },
    },
    async created() {
        await this.loadFollowupsOfCurrentUser();

    },
}
</script>
